export default __webpack_public_path__ + "static/banner-why-financial-freedom-is-worth-the-effort-f8f17f980f04892c0976ebe66a47fd38.jpg";